<template>
    <el-card shadow="never">
        <template #header>
          <div class="header">
            <el-breadcrumb class="breadcrumb" separator="/">
              <el-breadcrumb-item :to="{ path: '/' }">工作台</el-breadcrumb-item>
              <el-breadcrumb-item>名片样式列表</el-breadcrumb-item>
            </el-breadcrumb>
            <el-button type="primary" class="editbtn" @click="add">创建名片样式</el-button>
          </div>
        </template>
        <el-form :model="searchForm" inline label-width="120px">
          <el-form-item label="关键词">
            <el-input v-model="searchForm.words" placeholder="名称"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search">搜索</el-button>
            <el-button @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
    </el-card>
    <el-card shadow="never" style="margin-top:20px">
        <el-table row-key="id" v-loading="baseData.loading" border :data="tableData.data" style="width: 100%;margin-top: 10px;">
          <el-table-column prop="id" label="ID" width="60"/>
          <el-table-column prop="title" label="名称"/>
          <el-table-column prop="img" label="图片" width="150">
            <template #default="scope">
              <img :src="scope.row.img" style="width: 100px;height: 100px;"/>
            </template>
          </el-table-column>
          <el-table-column prop="backimg" label="背景图" width="150">
            <template #default="scope">
              <img :src="scope.row.backimg" style="width: 100px;height: 100px;"/>
            </template>
          </el-table-column>
          <el-table-column prop="postimg" label="分享底图" width="150">
            <template #default="scope">
              <img :src="scope.row.postimg" style="width: 100px;height: 100px;"/>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="创建时间" width="180"/>
          <el-table-column prop="status" label="默认状态" width="90" >
            <template #default="scope">
              <el-text v-if="scope.row.is_defult==1" type="success">默认</el-text>
              <el-text v-else type="danger"></el-text>
            </template>
          </el-table-column>
          <el-table-column prop="sort" label="顺序" width="90" />
          <el-table-column prop="status" label="状态" width="90" >
            <template #default="scope">
              <el-text v-if="scope.row.status==0" type="danger">冻结</el-text>
              <el-text v-if="scope.row.status==1" type="success">正常</el-text>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="140" >
            <template #default="scope">
              <el-button size="small" @click="edit(scope.row)" type="primary">编辑</el-button>
              <el-popconfirm
                confirm-button-text="是"
                cancel-button-text="否"
                title="确定删除吗?"
                @confirm="del(scope.row.id)"
              >
                <template #reference>
                  <el-button size="small" type="danger">删除</el-button>
                </template>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        
        <div class="pagestyle">
          <el-pagination
            v-model:current-page="searchForm.page"
            v-model:page-size="searchForm.limit"
            layout="sizes, prev, pager, next"
            :total="tableData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </el-card>

      <el-dialog v-model="baseData.tbox" :title="baseData.title">
        <el-form :model="form" label-width="120">
          <el-form-item label="名称">
            <el-input v-model="form.title" autocomplete="off" maxlength="150" show-word-limit/>
          </el-form-item>
          <el-form-item label="封面图">
            <el-row class="martop">
              <el-upload
                class="avatar-uploader"
                action=""
                :http-request="uploadImg"
                :show-file-list="false"
              >
                <img v-if="form.img" :src="form.img" class="avatar" />
                <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
              </el-upload>
            </el-row>
          </el-form-item>
          <el-form-item label="背景图">
            <el-row class="martop">
              <el-upload
                class="avatar-uploader"
                action=""
                :http-request="uploadBackImg"
                :show-file-list="false"
              >
                <img v-if="form.backimg" :src="form.backimg" class="avatar" />
                <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
              </el-upload>
            </el-row>
          </el-form-item>
          <el-form-item label="分享底图">
            <el-row class="martop">
              <el-upload
                class="avatar-uploader"
                action=""
                :http-request="uploadPostImg"
                :show-file-list="false"
              >
                <img v-if="form.postimg" :src="form.postimg" class="avatar" />
                <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
              </el-upload>
            </el-row>
          </el-form-item>
          <el-form-item label="顺序">
            <el-input v-model="form.sort" autocomplete="off" maxlength="10"/>
          </el-form-item>
          <el-form-item label="默认状态">
            <el-radio-group v-model="form.is_defult">
                <el-radio :label="1">默认</el-radio>
                <el-radio :label="0">不默认</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="状态">
            <el-radio-group v-model="form.status">
                <el-radio :label="1">正常</el-radio>
                <el-radio :label="0">禁止</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="baseData.tbox = false">取消</el-button>
            <el-button type="primary" @click="save()">
              提交
            </el-button>
          </span>
        </template>
      </el-dialog>
  </template>
  <script lang="ts" setup>
  import { reactive, onMounted } from 'vue'
  import { ElMessage, ElLoading } from 'element-plus'
  import api from '@/api/index'
  import {useRouter} from 'vue-router'
  import { cardApi } from '@/api/card'


  const router = useRouter()
  const searchForm:any = reactive({
    words:"",
    limit:10,
    page:1,
  })
  const baseData:any= reactive({
    loading:false,
    title:'',
    tbox:false,
    companylist:[],
  })
  const tableData:any = reactive({
    data:[],
    total:0,
  })
  const form:any = reactive({
    id: '',
    title:'',
    img:'',
    backimg:'',
    postimg:'',
    sort: 0,
    is_defult: 0,
    status: 1,
  })
  const search = () => {
    searchForm.page = 1
    getList()
  }
  const reset = () => {
    searchForm.page = 1
    searchForm.limit = 10
    searchForm.words = ""
    getList()
  }
  const handleSizeChange = (val:number) => {
    searchForm.limit = val
    searchForm.page = 1
    getList()
  }
  const handleCurrentChange = (val:any) => {
    searchForm.page = val
    getList()
  }
  const uploadBackImg = (params:any) => {
    const loading = ElLoading.service({lock: true})
    const file = params.file,formData1 = new FormData();
    formData1.append("file", file)
    api.commonApi.uploadImg(formData1).then((res:any)=>{
      loading.close()
        if(res.code == 200){
          ElMessage({
            message: res.message,
            type: 'success',
          })
          form.backimg = res.data.img
        }else{
          ElMessage.error(res.message)
        }
    })
  }
  const uploadPostImg = (params:any) => {
    const loading = ElLoading.service({lock: true})
    const file = params.file,formData1 = new FormData();
    formData1.append("file", file)
    api.commonApi.uploadImg(formData1).then((res:any)=>{
      loading.close()
        if(res.code == 200){
          ElMessage({
            message: res.message,
            type: 'success',
          })
          form.postimg = res.data.img
        }else{
          ElMessage.error(res.message)
        }
    })
  }
  const uploadImg = (params:any) => {
    const loading = ElLoading.service({lock: true})
    const file = params.file,formData1 = new FormData();
    formData1.append("file", file)
    api.commonApi.uploadImg(formData1).then((res:any)=>{
      loading.close()
        if(res.code == 200){
          ElMessage({
            message: res.message,
            type: 'success',
          })
          form.img = res.data.img
        }else{
          ElMessage.error(res.message)
        }
    })
  }
  const save = () => {
    baseData.loading = true
    if(form.id){
      api.cardApi.templetedit(form).then((res:any)=>{
        baseData.loading = false
        if(res.code==200){
          ElMessage({
            message: res.message,
            type: 'success',
          })
          baseData.tbox = false
          getList()
        }else{
          ElMessage.error(res.message)
        }
      })
    }else{
      api.cardApi.templetadd(form).then((res:any)=>{
        baseData.loading = false
        if(res.code==200){
          ElMessage({
            message: res.message,
            type: 'success',
          })
          baseData.tbox = false
          getList()
        }else{
          ElMessage.error(res.message)
        }
      })
    }
  }
  const getList = () => {
    localStorage.setItem('cardstempletpage',searchForm.page);
    localStorage.setItem('cardstempletwords',searchForm.words);
    localStorage.setItem('cardstempletlimit',searchForm.limit);
    baseData.loading = true
    api.cardApi.templetlist(searchForm).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        tableData.data = res.data.list
        tableData.total = res.data.total
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const add = () => {
    baseData.tbox = true
    baseData.title = '创建模板'
    form.id = 0
    form.title = ""
    form.img = ""
    form.backimg = ""
    form.postimg = ""
    form.sort = 0
    form.is_defult = 0
    form.status = 1
  }
  const edit = (data:any) => {
    baseData.tbox = true
    baseData.title = '编辑模板'
    form.id = data.id
    form.title = data.title
    form.img = data.img
    form.backimg = data.backimg
    form.postimg = data.postimg
    form.sort = data.sort
    form.is_defult = data.is_defult
    form.status = data.status
  }
  const del = (id:number) => {
    baseData.loading = true
    api.cardApi.templetdel({id:id}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  onMounted(() => {
    searchForm.page = localStorage.getItem('cardstempletpage') ? parseInt(localStorage.getItem('cardstempletpage')) : 1;
    searchForm.words = localStorage.getItem('cardstempletwords') ? localStorage.getItem('cardstempletwords') : '';
    searchForm.limit = localStorage.getItem('cardstempletlimit') ? parseInt(localStorage.getItem('cardstempletlimit')) : 10;
    getList()
  })
  </script>